<template>
  <v-dialog :value="visible" @input="$emit('update:visible', false)" max-width="500px" persistent>
    <v-card dark v-if="membership">
      <v-card-title class="text-h5 primary white--text"> Mitgliedschaft umbenennen </v-card-title>
      <v-card-text class="mt-4">
        <p class="white--text">
          Aktueller Name: <strong>{{ membership.title }}</strong>
        </p>
        <v-text-field v-model="newTitle" label="Neuer Titel" outlined dense :error-messages="errorMessage" @input="validate"></v-text-field>
        <v-alert type="warning" dense text class="mt-2"> Achtung: Diese Änderung wird in allen verknüpften Zusatzpaketen übernommen. </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('update:visible', false)">Abbrechen</v-btn>
        <v-btn color="primary" :disabled="!!errorMessage || !newTitle" @click="confirmRename"> Umbenennen </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "RenameMembershipDialog",
  props: {
    visible: Boolean,
    membership: Object,
    existingMemberships: Array,
  },
  data() {
    return {
      newTitle: "",
      errorMessage: "",
    }
  },
  watch: {
    visible(newVal) {
      if (newVal && this.membership) {
        this.newTitle = this.membership.title
        this.errorMessage = ""
      }
    },
  },
  methods: {
    validate() {
      const trimmedTitle = this.newTitle.trim()
      if (!trimmedTitle) {
        this.errorMessage = "Der Titel darf nicht leer sein."
        return
      }
      const isDuplicate = this.existingMemberships.some(
        (m) => m.title.toLowerCase() === trimmedTitle.toLowerCase() && m.title !== this.membership.title
      )
      if (isDuplicate) {
        this.errorMessage = "Eine Mitgliedschaft mit diesem Namen existiert bereits."
      } else {
        this.errorMessage = ""
      }
    },
    confirmRename() {
      this.validate()
      if (!this.errorMessage) {
        this.$emit("rename", { oldTitle: this.membership.title, newTitle: this.newTitle.trim() })
      }
    },
  },
}
</script>
